import MDBox from 'components/MDBox'
import React from 'react'
import CreateLinkModal from '../CreateLinkModal'
import { Grid } from '@mui/material'
import MUIDataTable from 'mui-datatables'
import { useEffect } from 'react'
import { useState } from 'react'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'

const index = ({ data, handleChange }) => {
  const Service = useAppServices()
  const [tableData, setTableData] = useState([])
  const columns = [
    {
      page: 'Name',
      options: {
        filter: false,
      },
    },
    {
      type: 'Type',
      options: {
        filter: false,
      },
    },
    {
      name: 'Action',
      options: {
        filter: false,
      },
    },
  ]

  const options = {
    filter: false,
    download: false,
    print: false,
    viewColumns: false,
    selectableRows: 'none',
    filterType: 'multiselect',
    responsive: 'standard',
  }
  const hadleDelete = async (index) => {
    const location_pages = data?.location_pages
    if (index > -1) {
      location_pages.splice(index, 1)
    }
    const payload = {
      location_pages: location_pages,
      _id: data._id,
    }
    const { response } = await Service.snapshot_onboarding.update({ payload })
    if (response) {
      handleChange()
    }
  }
  const onLoad = () => {
    var tabel_data = []
    data?.location_pages?.forEach((element, index) => {
      const temp = [
        element.page,
        element.linkType,
        <>
          <CreateLinkModal
            data={data}
            handleChange={handleChange}
            type="location"
            editData={element}
            DataIndex={index}
          />
          <MDButton
            variant="contained"
            color="error"
            size="small"
            sx={{ marginLeft: '4px' }}
            onClick={() => hadleDelete(index)}
          >
            Delete
          </MDButton>
        </>,
      ]
      tabel_data.push(temp)
    })
    setTableData(tabel_data)
  }
  useEffect(async () => {
    onLoad()
  }, [data])
  return (
    <MDBox>
      <MDBox display="flex" justifyContent="flex-end" mb={3}>
        <CreateLinkModal data={data} handleChange={handleChange} type="location" />
      </MDBox>
      <Grid item xs={12}>
        <MUIDataTable title={'Links'} data={tableData} columns={columns} options={options} />
      </Grid>
    </MDBox>
  )
}

export default index
